import { createContext, useContext } from 'react';

export const PlaybackContext = createContext<{ setAssetId: null | ((assetId: string) => void) }>({ setAssetId: null });

export const usePlaybackContext = () => {
  return useContext(PlaybackContext);
};
